// extracted by mini-css-extract-plugin
module.exports = {"select-component":"Select_select-component__Evyvg"};